import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import Link from '@mui/material/Link';

export const PrivacyDetails = () => {
  const { t } = useTranslation();

  return (
    <Stack gap="10px">
      <Typography fontWeight="medium">
        {t('welcomePage.p24MarketingForm.privacyDetails.title')}
      </Typography>
      <Link href="https://www.przelewy24.pl/obowiazek-informacyjny-rodo-akceptanci" target="_blank">
        <Typography>{t('welcomePage.p24MarketingForm.privacyDetails.link')}</Typography>
      </Link>
    </Stack>
  );
};
